"use strict";var e=require("./index-60d13e30.js");require("@igc-lib/platform"),module.exports=e.initUserCenter;
//# sourceMappingURL=index.js.map
